// Vendors
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import uuid from "react-native-uuid";

// Styles
import "./MarriageVerificationPage.scss";

// Components
import {
  GetStartedMarriageVerification,
  MarriageVerificationInfo,
} from "../../common";
import VerifyIdentityInState from "../../common/forms/verifyIdentity/VerifyIdentityInState";
import VerifyIdentityOutOfState from "../../common/forms/verifyIdentity/VerifyIdentityOutOfState";

// Navigation
import history from "./../../common/history";

// Hooks
import useGlobal from "../../../store";

// Helpers
import GetCanonicalUrl from "../../common/GetCanonicalUrl";
import { GetStateData, GetCountyData } from "referencedata";

function MarriageVerificationPage() {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [globalState, globalActions] = useGlobal();
  const [arrayIndex, setArrayIndex] = useState("");

  const nextStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(currentStep + 1);

    value
      ? setUrlForForm("marriageRecord", value)
      : setUrlForForm("marriageRecord", currentStep + 1);
  };
  const prevStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(currentStep - 1);

    value
    ? setUrlForForm("marriageRecord", value)
    : setUrlForForm("marriageRecord", currentStep - 1);
  };

  const setUrlForForm = (record, step) => {
    if (record === "marriageRecord") {
      switch (step) {
        case 0:
          history.push(t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER"));
          break;
        case 1:
          history.push(
            t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER") +
              t("URLS.VERIFY_IDENTITY_IN_STATE")
          );
          break;
        case 2:
          history.push(
            t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER") +
              t("URLS.VERIFY_IDENTITY_OUT_STATE")
          );
          break;
        case 3:
          history.push(
            t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER") +
              t("URLS.MARRIAGE_VERIFICATION_INFORMATION")
          );
          break;
        default:
          history.push(t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER"));
      }
    }
  };


  const firstStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(0);
    value
      ? setUrlForForm("marriageRecord", value)
      : setUrlForForm("marriageRecord", 0);
  };

  useEffect(() => { 
    if (!globalState.uniqueIdentifier) {
    globalActions.addUniqueIdentifier("OVRAREF_ID-" + uuid.v1());
  }

    globalActions.clearGlobalState();
    if (
      globalState.saveEditIndex.arrayIndex !== "" &&
      globalState.saveEditIndex.referenceType === "marriageVerification"
    ) {
      setArrayIndex(globalState.saveEditIndex.arrayIndex);
      globalState.getStartedMarriageVerificationInfo.dateOfMarriage = new Date(
        globalState.totalOrderRecords[
          globalState.saveEditIndex.arrayIndex
        ].dateOfMarriage
      );
      globalState.getStartedMarriageVerificationInfo.selectedState =
        globalState.totalOrderRecords[
          globalState.saveEditIndex.arrayIndex
        ].selectedState;
      globalState.marriageVerificationInfo =
        globalState.totalOrderRecords[globalState.saveEditIndex.arrayIndex];
    }
  }, []);

  return (
    <>
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <title>{t("MARRIAGE_VERIFICATION_INFO.TITLE")}</title>
            <meta
              name="description"
              content={t("MARRIAGE_VERIFICATION_INFO.META_CONTENT")}
            />
            <link
              rel="canonical"
              href={
                GetCanonicalUrl() +
                t("URLS.ORDER_MARRIAGE_VERIFICATION_LETTER_2")
              }
            />
          </Helmet>
          <Container className="lg-container">
            {currentStep === 0 && (
              <GetStartedMarriageVerification
                stateList={GetStateData()}
                nextCallback={nextStep}
              />
            )}
            {currentStep === 1 && (
              <VerifyIdentityInState
                stateList={GetStateData()}
                nextCallback={nextStep}
                prevCallback={prevStep}
                flowIndex="marriageVerification"
              />
            )}
            {currentStep === 2 && (
              <VerifyIdentityOutOfState
                stateList={GetStateData()}
                nextCallback={nextStep}
                prevCallback={firstStep}
                flowIndex="marriageVerification"
              />
            )}
            {currentStep === 3 && (
              <MarriageVerificationInfo
                countyList={GetCountyData()}
                editIndex={arrayIndex}
              />
            )}
          </Container>
        </div>
    </>
  );
}

export default MarriageVerificationPage;
